import { useQuery } from '@tanstack/react-query';
import { UseQueryCustomResult } from '../types';
import { LatestTag } from '@internal/backstage-plugin-bidone-backend';
import { useAuthedFetch } from './useAuthedFetch';

const useBitbucketTags = (
  repos: string[],
): UseQueryCustomResult<Record<string, LatestTag>> => {
  const authedFetch = useAuthedFetch();

  return useQuery({
    queryKey: ['useBitbucket', 'useBitbucketTags', ...repos],
    queryFn: async () =>
      authedFetch(`/bitbucket/tags`, {
        method: 'POST',
        json: repos,
      }),
  });
};

export { useBitbucketTags };
